import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthGuard } from './core/guards/auth.guard';
import { DocumentationComponent } from './pages/dashboard/documentation/documentation.component';
import { KibanaDashboardComponent } from './pages/dashboard/kibana-dashboard/kibana-dashboard.component';

export const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'landing-page/:organizationName',
    loadChildren: () =>
      import('./pages/landing-page/landing-pages.module').then(
        (m) => m.LandingPagesModule
      ),
  },
  {
    path: 'kibana',
    component: KibanaDashboardComponent,
  },
  {
    path: 'documentation',
    canActivate: [AuthGuard],
    component: DocumentationComponent,
  },
  {
    path: 'plan/:planId',
    loadChildren: () =>
      import('./pages/buy-plan/buy-plan.module').then(
        (m) => m.BuyPlanPageModule
      ),
  },
  {
    path: 'form/:id',
    loadChildren: () =>
      import('./pages/form-builder/form.module').then((m) => m.FormModule),
  },
  {
    path: 'online-survey/:id',
    loadChildren: () =>
      import('./pages/online-surveys/online-survey/online-survey.module').then(
        (m) => m.OnlineSurveyModule
      ),
  },
  // {
  //   path: ':pageName/:param',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./layout/layout.module').then((m) => m.LayoutModule),
  // },
  {
    path: ':pageName',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
